import React, { createContext, useState } from "react";
import InputText from "./InputText";
import { accountDelete, changePassword } from "../../services/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthStore } from "../../redux/features/authSlice";
import { setToken } from "../../utils/axiosClient";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
export const ComponentContext = createContext();

const DeleteAccountModal = ({ isOpen, onClose }) => {
  const [reason, setReason] = useState([
    {
      id: 1,
      reason: "I no longer need this account.",
    },
    {
      id: 2,
      reason: "I have privacy concerns.",
    },
    {
      id: 3,
      reason: "I receive too many notifications.",
    },
    {
      id: 4,
      reason: "I'm not satisfied with the service.",
    },
    {
      id: 5,
      reason: "Other...",
    },
  ]);

  const [selectedReason, setSelectedReason] = useState("");
  const [reasonText, setReasonText] = useState("");
  const { loginInfo, removeLoginInfo } = useAuthStore();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const deleteAccountAPI = async () => {
    try {
      setToken(loginInfo ? loginInfo?.token : null);
      // setLoading(true);
      const payload = {
        deleteReason: reasonText,
      };
      const response = await accountDelete(payload);
      if (response?.data?.statusCode == 200) {
        onClose();
        toast.success(
          response?.data?.message || t("deleteaccount_success"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        removeLoginInfo();
        navigate(i18n.language === 'en' ? '/en' : '/');
      } else {
        toast.error(
          response?.data?.message || t("deleteaccount_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error in change password: ", error);
    } finally {
      // setLoading(false);
    }
  };
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 flex p-5 items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 rounded-[30px] shadow-lg w-[450px]"
      >
        {/* Modal Header */}

        <div className="overflow-y-scroll max-h-[500px]">
          <h2 className="text-2xl text-primary-text font-semibold text-center">
            {t("deleteaccount_title")}
          </h2>

          <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
            {t("deleteaccount_subtitle")}
          </h5>

          <div className="flex flex-col gap-2 mt-3">
            {reason.map((reason) => (
              <div
                onClick={() => {
                  setSelectedReason(reason.id);
                  setReasonText(reason.reason);
                }}
                className={`${
                  selectedReason == reason.id
                    ? "border-red-600"
                    : "border-[#E5EAF1]"
                } border text-[#3C4043] cursor-pointer text-base font-semibold  rounded-[58px] p-2 px-3`}
              >
                {t(`deleteaccount_reason_${reason.id}`)}
              </div>
            ))}
          </div>

          <div className="mt-4 text-center">
            <button
              className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold"
              onClick={deleteAccountAPI}
            >
              {t("deleteaccount_continue")}
            </button>
            <button
              onClick={() => {
                onClose();
                navigate(i18n.language === 'en' ? '/en' : '/');
              }}
              className="text-[#5D5D5D] text-base text-center mt-4 font-semibold"
              type="button"
            >
              {t("deleteaccount_cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
